export type ClientGroup = {
  label: string;
  examples: string;
};

export const clientGroups: ClientGroup[] = [
  {
    label: 'Collectivités territoriales',
    examples: 'Métropoles, communautés d’agglomération, communes, départements',
  },
  {
    label: 'Bailleurs sociaux',
    examples: 'Offices publics de l’habitat, ESH, sociétés coopératives',
  },
  {
    label: 'Opérateurs publics et aménageurs',
    examples: 'SEM, SPL, établissements publics fonciers et d’aménagement',
  },
  {
    label: 'Services de l’État et agences',
    examples: 'DDT, DREAL, partenaires nationaux de l’habitat et de la ville',
  },
];
